import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {NgxSpinnerService} from "ngx-spinner";
import Me from "../helpers/me";
import App from "../helpers/app";
import Api from "../helpers/api";
import {take} from "rxjs/operators";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

interface Filters {
  nome?: string;
  login?: string;
  periodoCadastroInicio?: string;
  periodoCadastroFim?: string;
}

@Component({
  selector: 'app-administradores',
  templateUrl: './administradores.component.html',
  styleUrls: ['./administradores.component.scss']
})
export class AdministradoresComponent implements OnInit {
  apiCall = this.api.new().silent();
  pageAd = 1
  pageSizeAd = 5
  administradores = []
  administradoresOriginal = []
  atualizacaoSenha = {
    novaSenha: null,
    confirmaNovaSenha: null,
  }
  novoAdministrador = {
    nome: null,
    login: null,
    senha: null,
    confirmaSenha: null
  }
  userToUpdate = null

  // Filtros
  filters: Filters = {
    nome: null,
    login: null,
    periodoCadastroInicio: null,
    periodoCadastroFim: null
  };

  // Propriedades para ordenação
  currentSortColumn: string = '';
  currentSortDirection: string = 'asc';

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private me: Me,
    private app: App,
    private api: Api
  ) {
  }

  async ngOnInit(){
    const self = this
    self.atualizacaoSenha = {
      novaSenha: null,
      confirmaNovaSenha: null,
    }
    self.userToUpdate = null
    self.novoAdministrador = {
      nome: null,
      login: null,
      senha: null,
      confirmaSenha: null
    }
    self.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });

    const admin = await self.apiCall.get('users/lista/admin').pipe(take(1)).toPromise()
    self.administradores = JSON.parse(JSON.stringify(admin));
    self.administradoresOriginal = JSON.parse(JSON.stringify(admin));
    self.spinner.hide()
  }

  // Métodos de filtro
  applyFilters() {
    let filteredData = [...this.administradoresOriginal];

    // Filtro por nome
    if (this.filters.nome && this.filters.nome.trim() !== '') {
      filteredData = filteredData.filter(admin => 
        admin.nome && admin.nome.toLowerCase().includes(this.filters.nome.toLowerCase())
      );
    }

    // Filtro por login
    if (this.filters.login && this.filters.login.trim() !== '') {
      filteredData = filteredData.filter(admin => 
        admin.login && admin.login.toLowerCase().includes(this.filters.login.toLowerCase())
      );
    }

    // Filtro por período de cadastro (se houver campo data_cadastro nos dados)
    if (this.filters.periodoCadastroInicio && this.filters.periodoCadastroInicio.trim() !== '') {
      const dataInicio = this.convertDateFormat(this.filters.periodoCadastroInicio);
      if (dataInicio) {
        filteredData = filteredData.filter(admin => {
          if (admin.data_cadastro) {
            const dataCadastro = new Date(admin.data_cadastro);
            return dataCadastro >= new Date(dataInicio);
          }
          return true;
        });
      }
    }

    if (this.filters.periodoCadastroFim && this.filters.periodoCadastroFim.trim() !== '') {
      const dataFim = this.convertDateFormat(this.filters.periodoCadastroFim);
      if (dataFim) {
        filteredData = filteredData.filter(admin => {
          if (admin.data_cadastro) {
            const dataCadastro = new Date(admin.data_cadastro);
            return dataCadastro <= new Date(dataFim);
          }
          return true;
        });
      }
    }

    // Aplicar ordenação se houver
    if (this.currentSortColumn) {
      filteredData = this.sortData(filteredData, this.currentSortColumn, this.currentSortDirection);
    }

    this.administradores = filteredData;
    this.pageAd = 1; // Reset para primeira página
  }

  clearFilters() {
    this.filters = {
      nome: null,
      login: null,
      periodoCadastroInicio: null,
      periodoCadastroFim: null
    };
    this.currentSortColumn = '';
    this.currentSortDirection = 'asc';
    this.administradores = [...this.administradoresOriginal];
    this.pageAd = 1;
  }

  // Métodos de ordenação
  sortTable(column: string) {
    if (this.currentSortColumn === column) {
      this.currentSortDirection = this.currentSortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.currentSortColumn = column;
      this.currentSortDirection = 'asc';
    }

    this.pageAd = 1; // Reset para primeira página
    this.applyFilters(); // Reaplicar filtros com nova ordenação
  }

  sortData(data: any[], column: string, direction: string): any[] {
    return data.sort((a, b) => {
      let valueA = a[column];
      let valueB = b[column];

      // Tratar valores nulos/undefined
      if (valueA == null) valueA = '';
      if (valueB == null) valueB = '';

      // Converter para string para comparação
      valueA = valueA.toString().toLowerCase();
      valueB = valueB.toString().toLowerCase();

      if (direction === 'asc') {
        return valueA.localeCompare(valueB);
      } else {
        return valueB.localeCompare(valueA);
      }
    });
  }

  // Método para mostrar indicador de ordenação
  getSortIcon(column: string): string {
    if (this.currentSortColumn === column) {
      return this.currentSortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down';
    }
    return '';
  }

  // Método para verificar se a coluna está sendo ordenada
  isColumnSorted(column: string): boolean {
    return this.currentSortColumn === column;
  }

  // Converter formato de data de dd/mm/yyyy para yyyy-mm-dd
  convertDateFormat(dateString: string): string | null {
    if (!dateString) return null;
    
    const parts = dateString.split('/');
    if (parts.length === 3) {
      const day = parts[0].padStart(2, '0');
      const month = parts[1].padStart(2, '0');
      const year = parts[2];
      return `${year}-${month}-${day}`;
    }
    return null;
  }

  async updateSenha(modal){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    await this.apiCall.get(`users/edicao/senha?idUsuario=${this.userToUpdate.id}&senha=${this.atualizacaoSenha.novaSenha}&tipoUsuario=1`).pipe(take(1)).toPromise()
    this.spinner.hide()
    await this.app.alert('Tudo certo!', 'Senha atualizada com sucesso!', 'success')
    modal.close('Close click')
    await this.ngOnInit()
  }

  openModal(content, usuario){
    this.userToUpdate = usuario
    const modal = this.modalService.open(content, { centered: true })
  }

  async insertAdministrador(modal){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    
    const verification = await this.apiCall.get('users/verificacao/admin?login='+this.novoAdministrador.login).pipe(take(1)).toPromise()
    if(verification){
      this.spinner.hide()
      await this.app.alert('Ops', 'Este usuário já existe! informe outro login.', 'error')
      return
    }
    
    await this.apiCall.get(`users/novo?tipoUsuario=1&nome=${this.novoAdministrador.nome}&cidade=null&senha=${this.novoAdministrador.senha}&login=${this.novoAdministrador.login}`).pipe(take(1)).toPromise()
    this.spinner.hide()
    await this.ngOnInit()
    await this.app.alert('Tudo certo!', 'Administrador cadastrado com sucesso!', 'success')
    modal.close('Close click')
  }
} 